const getters = {
  getCustomers: (state) => state.customers,
  getCustomersMeta: (state) => state.customersMeta,
  getCustomer: (state) => state.customer,
  getCustomerMeta: (state) => state.customerMeta,
  getStatuses: (state) => state.statuses,
};

export default getters;
